import React from "react";
import "./style.css";

function styledh4(props) {
  return <h1 className="styledh4">{props.children}</h1>;
}

export default styledh4;
